import { gql } from '@apollo/client';

export const CANCEL_INVENTORY_REQUEST = gql`
  mutation CancelInventoryRequest($request_id: String!) {
    cancelInventoryRequest(request_id: $request_id) {
      status
      message
      inventory_requests {
        inv_id
        date
        status
      }
    }
  }
`;
